module.exports = __webpack_public_path__ + "static/media/vegetarian.4bf057a1.svg";